import { IGraphSearchUrlBuilder } from "../../../interfaces/IGraphSearchUrlBuilder";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { SearchValue } from "../../../redux/models/reduxModels";
import { BaseUrlSearchBuilder } from "./baseUrlSearchBuilder";
import { SearchFilterBuilder } from "../../../../../utilities/SearchFilterBuilder";

export class SharepointSiteSearchUrlBuilder extends BaseUrlSearchBuilder implements IGraphSearchUrlBuilder {
    constructor(private oneDriveWebUrl: string) {
        super()
    }

    buildFolderQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(currentDirectory, searchValue, false);
    }

    buildFileQuery = (currentDirectory: IPageSettings, searchValue: SearchValue) => {
        return this.builSearchUrl(currentDirectory, searchValue, true);
    }

    private builSearchUrl = (currentDirectory: IPageSettings, searchValue: SearchValue, isFile: boolean) => {
        if (this.oneDriveWebUrl) {
            return `(*${searchValue.value}*) -path:${this.oneDriveWebUrl} ${this.setFileType(isFile)} ${searchValue?.filterType !== "" ? SearchFilterBuilder(searchValue.filterType) : ""}`;
        }
        else {
            return `(*${searchValue.value}*) ${this.setFileType(isFile)} ${searchValue?.filterType !== "" ? SearchFilterBuilder(searchValue.filterType) : ""}`;
        }
    }
}